// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanLine.yaml
// Generated: 2026-06-15T16:19:29.212Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanLine, UpdatePlanLine, PlanLine } from '@/types/finance/PlanLine';

/**
 * PlanLine Service
 * CRUD operations for PlanLine via the ABP API.
 */
export const planLineService = new EntityService<PlanLine, CreatePlanLine, UpdatePlanLine>(
  '/api/finance/planline',
  'PlanLine',
);
